<template>
  <div>
    <el-table
      :data="campaigns"
      :highlight-current-row="true"
      stripe
      row-class-name="pointer"
      ref="campaignTable"
    >
      <el-table-column label="Name" prop="name"></el-table-column>
      <el-table-column label="Track" prop="vc_campaign_track.track.title">
      </el-table-column>
      <el-table-column label="VC Budget">
        <template slot-scope="props">
          {{ props.row.vc_campaign_track.vc_invested.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column label="VC Balance">
        <template slot-scope="props">
          {{
            props.row.vc_campaign_track.balance.toFixed(
              2
            )
          }}
        </template>
      </el-table-column>
      <el-table-column label="Starting">
        <template slot-scope="props">
          {{ props.row.vc_campaign_track.campaign_track_start | date }}
        </template>
      </el-table-column>
      <el-table-column label="Ending">
        <template slot-scope="props">
          {{ props.row.vc_campaign_track.campaign_track_end | date }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right">
        <template slot-scope="props">
          <el-tooltip content="Deposit" placement="top">
            <el-button
              type="success"
              circle
              size="small"
              icon="el-icon-money"
              @click="openDeposit(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Download" placement="top">
            <el-button
              type="default"
              circle
              size="small"
              icon="el-icon-download"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('artistVidCents', ['campaigns']),
    ...mapState('artistTrackVidCents', ['active_campaign'])
  },

  watch: {
    active_campaign() {
      this.$refs.campaignTable.setCurrentRow(this.active_campaign)
    }
  },

  methods: {
    ...mapActions('artistTrackVidCents', ['readTracks']),
    ...mapMutations('artistVidCents', ['setCampaign', 'setCampaignDeposit']),
    ...mapMutations('artistTrackVidCents', [
      'setActiveCampaign',
      'setTrackDialog'
    ]),

    openDeposit(row) {
      this.setCampaignDeposit(true)
      this.setCampaign(row)
    },
    openTrackTable(row) {
      this.setActiveCampaign(row)
      this.readTracks()
    },
    openTrackDialog(row) {
      this.setActiveCampaign(row)
      this.setTrackDialog(true)
    }
  }
}
</script>
